export default {
	token: null,
	tokenExp: null,
	refreshAfter: null,
	tokenRefreshInProgress: false,
	profile: {},
	isInit: false
};
